'use client'

import s from './grid-image.module.css'
import { Slider } from '@/components/v2/atoms/slider/slider'
import { Image } from '@/components/v2/atoms/image/image'
import { SLIDER_CLASS_NAME } from '@/constants'
import cx from 'classnames'
import { useState } from 'react'
import { ArrowRight } from '@/components/svg/arrow-right/arrow-right'
import { ImageLightboxV3 } from '@/components/v3/molecules/image-lightbox/image-lightbox'
import {
  ImageSimple,
  provideImageGridSectionDBValueBackwardsCompatibility,
} from '@/utils/articleWidgetsBackwardCompatibility'
import { VideoIcon } from '@/components/svg/video-icon/video-icon'
import { KeenSliderOptions } from 'keen-slider'
import { ImagesIcon } from '@/components/svg/images-icon/images-icon'

type Props = {
  mainDescription?: string
  images: ImageSimple[] | { images: ImageSimple[] }
  sliderOptions?: KeenSliderOptions
  blackArrow?: boolean
  withCounter?: boolean
}

export const GridImageV3 = ({
  mainDescription,
  images,
  sliderOptions,
  blackArrow,
  withCounter,
}: Props) => {
  const [indexDisplay, setIndexDisplay] = useState(-1)
  const imagesArray =
    provideImageGridSectionDBValueBackwardsCompatibility(images)

  return (
    <>
      <section className={s.container}>
        <Slider
          options={{
            slides: {
              spacing: 4,
              perView: 'auto',
            },
            loop: true,
            ...sliderOptions,
          }}
          autoMove
          ignoreDefaultBreakpoints
          renderNavigation={(slideLeft, slideRight) => {
            return (
              <>
                <button
                  type="button"
                  className={cx(s.sliderPrevArrow, {
                    [s.arrowBlack]: blackArrow,
                  })}
                  onClick={slideLeft}
                  aria-label="Previous image"
                >
                  <ArrowRight
                    iconColor={blackArrow ? '#131313' : '#fff'}
                    svgProps={{
                      style: {
                        transform: 'rotate(180deg)',
                      },
                    }}
                  />
                </button>
                <button
                  type="button"
                  className={cx(s.sliderNextArrow, {
                    [s.arrowBlack]: blackArrow,
                  })}
                  onClick={slideRight}
                  aria-label="Next image"
                >
                  <ArrowRight iconColor={blackArrow ? '#131313' : '#fff'} />
                </button>
              </>
            )
          }}
        >
          {imagesArray.map((image, idx) => {
            const isHorizontal =
              image?.width && image?.height && image?.width > image?.height
            const videoUrl = image?.videoUrl

            return (
              <button
                className={cx(SLIDER_CLASS_NAME, s.imageContainer, {
                  [s.imageLandscape]: isHorizontal,
                })}
                key={image.url}
                onClick={() => setIndexDisplay(idx)}
              >
                <Image
                  src={image.url}
                  alt={image.alt}
                  width={1000}
                  height={1000}
                  className={cx(s.image, {
                    [s.imageLandscape]: isHorizontal,
                  })}
                  fit
                />
                {videoUrl && (
                  <VideoIcon
                    svgProps={{
                      className: s.videoIcon,
                    }}
                  />
                )}
              </button>
            )
          })}
        </Slider>
        {!!mainDescription && (
          <p className={s.mainDescription}>
            <span dangerouslySetInnerHTML={{ __html: mainDescription }} />
            &nbsp;(
            {imagesArray.length})
          </p>
        )}
        {withCounter && (
          <button
            className={s.counterContainer}
            onClick={() => setIndexDisplay(0)}
            aria-label={`View all ${imagesArray.length} images`}
          >
            <ImagesIcon />
            {imagesArray.length}
          </button>
        )}
      </section>

      <ImageLightboxV3
        images={imagesArray}
        indexDisplay={indexDisplay}
        setIndexDisplay={setIndexDisplay}
      />
    </>
  )
}

